import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GetMonthBillList({ commit, rootGetters }, request) {
      return axios
        .post('MonthBill/GetOemMonthBillList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemOrderClient({ commit, rootGetters }, request) {
      return axios
        .get('MonthBill/GetOemOrderClient', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemClosure({ commit, rootGetters }, request) {
      return axios
        .post('MonthBill/GetOemClosure', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetMonthBillByID({ commit, rootGetters }, request) {
      return axios
        .post('MonthBill/GetMonthBillByID', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOemMonthBill({ commit, rootGetters }, request) {
      return axios
        .post('MonthBill/AddOemMonthBill', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOemMonthBill({ commit, rootGetters }, request) {
      return axios
        .put('MonthBill/UpdateOemMonthBill', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DelOemMonthBill({ commit, rootGetters }, request) {
      return axios
        .delete('MonthBill/DelOemMonthBill', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    BillReportExcel({ commit, rootGetters }, request) {
      return axios
        .get('MonthBill/BillReportExcel', { params: request, responseType: 'blob' })
        .then((response) => {
          if (response.status === 200) {
            const res = {
              blob: response.data,
              fileName: response.headers['content-disposition']
            }
            return Promise.resolve(res)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
